module.exports = __webpack_public_path__ + "static/UnclickDamagedLostItem-6e9cf570a03332ffc09aa5a32808c41a.png";